import React from 'react';
import Relay from 'common/oldJavascripts/utils/react/Relay';
import LayoutContent from 'common/oldJavascripts/components/Base/Layout/LayoutContent';
import OfferLayout from '../Layouts/Offer';
import RescindErrorModal from './Offers/Modal/RescindErrorModal';
import OffersTable from './Offers/Table';
import history from 'common/constants/config/history';

export default Relay.createClass({
  getInitialState() {
    return {
      showModal: false,
    };
  },

  render: function() {
    var modal = null;
    // TODO:
    // This should not be using local storage
    // Remove that logic and then display the modal based on the props, not state
    if (
      localStorage['isOfferRescinded'] ||
      this.props.routerQuery.isOfferRescinded === ''
    ) {
      this.setState({ showModal: true });
      modal = <RescindErrorModal onClose={this._modalClose} />;
    }

    return (
      <OfferLayout>
        <LayoutContent>
          <OffersTable type="sent" params={{ status: 'new' }} />
          <OffersTable type="submitted" params={{ status: 'submitted' }} />
          <OffersTable type="approved" params={{ status: 'approved' }} />
          <OffersTable
            type="employeeRejected"
            params={{ status: 'rejected' }}
          />
          <OffersTable type="optedOut" params={{ status: 'opted-out' }} />
        </LayoutContent>
        {modal}
      </OfferLayout>
    );
  },

  _modalClose() {
    const { routerPath } = this.props;
    this.setState({ showModal: false });
    localStorage.removeItem('isOfferRescinded');
    history.push(routerPath);
  },
});
